import { AppBar, Toolbar } from '@mui/material'
import { AlertPosition, SubmitButtonWithAlert } from '../../../../../components'

export const BottomBar = () => {
  return (
    <AppBar
      color="primary"
      elevation={10}
      position="fixed"
      sx={{
        top: 'auto',
        bottom: 0
      }}
    >
      <Toolbar>
        <SubmitButtonWithAlert
          alertProps={{
            alertPosition: AlertPosition.RIGHT
          }}
          justifyContent="flex-end"
        />
      </Toolbar>
    </AppBar>
  )
}
